<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">Upgrade Your Account Limit</h2>
			</div>
		</div>
		<!-- eo main header -->

		<div class="main-section mgt-40">
			<div class="container">

				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />

					<div class="row">
						<!--	<div class="col-lg-12">
		<h1> KYC Verification:</h1>
		<hr />
		<p class="m-t-lg m-b-lg">
			To upgrade your account to KYC, Please provide the following documents for our face to face verification
		</p>


		<ul>
			<li>
				For Malaysian: <b>Original MyKad</b>
			</li>
			<li>
				For Foreigner: <b>Original Passport</b> and <b>Employment visa</b>
			</li>
		</ul>

		<p>
			Collection of the identification documents can be arranged, kindly contact our Customer Care Consultant at:
			<br />
			<br />
			Tel: 1300888606<br />
			Email: customercare@eremit.com.my
		</p>
		<p>
			Please email to customercare@eremit.com.my with subject "<b>Document Collection</b>".
		</p>
		<ol>
			<li>Residence/Work place address</li>
			<li>Mobile number</li>
			<li>Date & time</li>
		</ol>
		<p>
			You may also visit any of our nearest branch, for identity Verification Process: <a style="color:blue;font-weight:bold" href="http://eremit.com.my/contact-us-branch-location.aspx" target="_blank"> Branch Address</a>
		</p>

		<p>
			Our Branch are open every day(including Public Holiday) form 9:00am to 6:00pm.
		</p>

		<p class="text-center" style="margin-top:25px">
			<button @click="downloadInvoice" class="btn btn-red btn-icon btn-icon-standalone btn-icon-standalone btn-lg">
				<i class="fas fa-file-pdf-o"></i>
				<span>Download Registration Form</span>
			</button>

		</p>

	</div> -->

						<div class="ekyc_mobile">
							<p>
								To increase your account limit, a face-to-face verification is needed to comply with
								regulatory
								procedures.
							</p>
							<div class="from_part">
								<div> From: </div>
								<ul>
									<li>
										<span> Malaysian or Expatriate </span>
										<strong> Transaction Limit: RM 30,000/day </strong>
									</li>
									<li>
										<span> Migrant Worker/Others </span>
										<strong> Transaction Limit: RM 5,000/month </strong>
									</li>
								</ul>
							</div>
							<!--end From-part-->

							<div class="trns_limit">
								To Transaction Limit: RM 50,000/day
							</div>
							<div class="sml_note">

								You may visit any of our branches nationwide daily from 9:00am-5:00pm
							</div>
							<div class="bottom_part">
								<p>Do bring along these original documents for the verification purposes </p>
								<div class="red_color_list">
									<span> i) Mykad (Malaysian)</span>
									<span> ii) Passport (Foreigners) </span>
								</div>
								<div class="sml_note note">
									<span>*Note: </span>
									We also provide on-site verification by visiting your place of residence or office.
									Kindly contact us
									at +603-8313 8606 & +603-7724 2070 to
									schedule an appointment
								</div>
								<div class="dwn_btn">
									<button @click="downloadInvoice">
										<i class="fas fa-file-pdf-o"></i>
										<span>Download Registration Form</span>
									</button>
								</div>

							</div>


						</div>
						<!--end wrapper ekyc_moile-->

					</div>
					<!-- eo row -->

				</div>
				<!-- eo main card -->

			</div>
			<!-- eo container -->
		</div>
		<!-- eo main section -->
	</div>
</template>
<script>
	import CommonService from "../../services/common";
	export default {
		name: "UpgradeToKYC",
		beforeRouteEnter(to, from, next) {
			next();
		},
		created() {

		},
		mounted() {

		},
		data() {
			return {
				vModel: {
					Token: null,
				}
			};
		},
		methods: {
			downloadInvoice: function () {
				var token = CommonService.getStorage('token');
				var cvrForm = document.createElement("form");
				document.body.appendChild(cvrForm);
				cvrForm.setAttribute(
					"action",
					CommonService.getBaseUrl("/") + "customer/upgradetokyc"
				);
				cvrForm.setAttribute("method", "post");
				cvrForm.setAttribute("target", "_blank");
				var formContent = "";
				formContent += "<input type='hidden' name='Token' value='" + token + "'/>";
				cvrForm.innerHTML = formContent;
				cvrForm.submit();
				document.body.removeChild(cvrForm);
			}
		}
	};
</script>
<style scoped>
	.ekyc_mobile {
		padding: 15px;
		margin: 0 auto;
		display: block;
	}

	.from_part ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.from_part ul li span {
		display: block;
		font-weight: bold;
		color: #3C4C5F;
	}

	.from_part ul li {
		margin-bottom: 21px;
		position: relative;
		padding-left: 50px;
	}

	.from_part ul li strong {
		color: #E20000;
	}

	.from_part ul li:before {
		content: '';
		height: 30px;
		width: 30px;
		background: #3C4C5F;
		position: absolute;
		border-radius: 50%;
		color: #fff;
		left: 11px;
		line-height: 30px;
		top: 5px;
		text-align: center;
		font-weight: bold;
	}

	.from_part ul li:first-child:before {
		content: '1';
	}

	.from_part ul li:last-child:before {
		content: "2"
	}

	.trns_limit {
		max-width: 678px;
		margin: 0 auto;
		background: #3C4C5F;
		padding: 15px;
		border-radius: 5px;
		color: #fff;
		text-align: center;
	}

	.sml_note {
		margin: 15px 0;
		font-size: 90%;
		font-style: italic;
	}

	.ekyc_mobile {
		color: #3C4C5F;
	}

	.red_color_list {
		margin: 11px 0;
	}

	.red_color_list span {
		display: block;
		color: #E20000;
		font-weight: bold;
		margin-bottom: 6px;
	}

	.dwn_btn {
		max-width: 678px;
		margin: 0 auto;
		background: #E20000;
		padding: 15px;
		border-radius: 5px;
		color: #fff;
		margin-top: 50px;
		text-align: center;
	}

	.dwn_btn button {
		color: #fff;
		text-transform: uppercase;
		text-decoration: none;
		font-weight: bold;
		background: transparent;
		border: 0px;
	}
</style>
